import {ChangeDetectionStrategy,Component,inject} from '@angular/core';
import {Meta,Title} from '@angular/platform-browser';
import {MATERIAL_IMPORTS} from '../shared/material-imports';
import {COMMON_IMPORTS} from '../shared/common-imports';
import {environment} from '../../environments/environment';
import {AppService} from '../app.service';

@Component({
	selector:'app-terms-of-use',
	imports:[
		...MATERIAL_IMPORTS,
		...COMMON_IMPORTS
	],
	templateUrl:'./terms-of-use.html',
	styleUrl:'./terms-of-use.scss',
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class TermsOfUseComponent{
	protected readonly environment=environment;

	readonly appService=inject(AppService);
	private readonly titleService=inject(Title);
	private readonly meta=inject(Meta);

	readonly title=$localize`:@@terms-of-use-title|Terms of use page title:L&O Medical - Términos de uso`;

	constructor(){
		const description=$localize`:@@terms-of-use-description|Terms of use SEO description:Condiciones de uso del sitio web de L&O Medical, incluido el carácter informativo de su contenido y la ley aplicable en Colombia.`;
		this.titleService.setTitle(this.title);
		this.meta.updateTag({content:this.title},'property="og:title"');
		this.meta.updateTag({content:description},'name="description"');
		this.meta.updateTag({content:description},'property="og:description"');
		this.meta.updateTag({content:$localize`:@@seo-keywords-default|Default SEO keywords:lyo, l&o, medical, medicina, biorreguladora, sueroterapia, autosanguis, bogotá, soacha, ibagué`},'name="keywords"');
		this.meta.updateTag({content:this.appService.ogImageUrl},'property="og:image"');
	}
}
